import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.USER };
const path = "/user"


export const GetStreams = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/get-live-streams`, value);
}

export const GetStreamsDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/streams/get-streamer-details?sellerId=${id}`);
}
export const getLiveStreamProducts = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/get-stream-products`, value);
}

export const createLeads = async (value) => {
  return await axiosInstance(options).post(`${path}/leads/create`, value);
}



export const getStreamProducts = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/get-stream-products`, value);
}
export const getStreamDetails = async (id) => {
  return await axiosInstance(options).post(`${path}/streams/get-stream-details`, { id });
};

export const subscribeReminder = async (stream_id) => {
  return await axiosInstance(options).post(`${path}/streams/subscribe-reminder`, { stream_id });
};

export const globalsearchData = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/global-search`, value);
}
export const getSellerProfile = async (id, body = {}) => {
  const safeId = typeof id === "string" && id.startsWith("@") ? `@${encodeURIComponent(id.slice(1))}` : encodeURIComponent(id);
  return await axiosInstance(options).post(
    `${path}/streams/get-seller-profile/${safeId}`,
    body
  );
};

export const getStaffAssignedStreams = async (value) => {
  return await axiosInstance(options).post(`advertiser${path}/staff-streams`, value);
};

export const getNotifications = async (page = 1, limit = 20) => {
  return await axiosInstance(options).get(`${path}/user/get-notifications?page=${page}&limit=${limit}`);
};

export const markNotificationAsRead = async (notification_id) => {
  return await axiosInstance(options).post(`${path}/user/mark-notification-read`, { notification_id });
};

export const markAllNotificationsRead = async (notification_ids = [], mark_all = true) => {
  return await axiosInstance(options).post(`${path}/user/mark-all-notifications-read`, {
    mark_all,
    notification_ids,
  });
};



export const acceptProduct = async (id, stream_id) => {
  return await axiosInstance(options).put(`advertiser/streams/accept-live-stream-product`, { _id: id, stream_id });
};

export const undoAcceptProduct = async (id, stream_id) => {
  return await axiosInstance(options).put(`advertiser/streams/undo-accept-live-stream-product`, { _id: id, stream_id });
};

export const addProductToStream = async (data) => {
  return await axiosInstance(options).post(`advertiser/streams/add-product-to-stream`, data);
};

export const updateLiveStreamProduct = async (data) => {
  return await axiosInstance(options).put(`advertiser/streams/update-live-stream-product`, data);
};

export const deleteLiveStreamProduct = async (id) => {
  return await axiosInstance(options).delete(`user/products/delete-ai-product?o_id=${id}`);
};
export const favouriteUnfavouriteStream = async (stream_id) => {
  return await axiosInstance(options).put(`advertiser/streams/favourite-unfavourite-stream?stream_id=${stream_id}`);
};

export const getFavouriteStreams = async () => {
  return await axiosInstance(options).get(`${path}/streams/get-favourite-streams`);
};

export const getMyActivity = async () => {
  return await axiosInstance(options).get(`${path}/leads/myActivity`);
};

export const getStreamComments = async (stream_id) => {
  return await axiosInstance(options).post(`${path}/streams/get-stream-comments`, { stream_id });
};

export const assignStaffToStream = async (stream_id, staff_ids) => {
  return await axiosInstance(options).post(`advertiser/streams/assign-staff`, { stream_id, staff_ids });
};

export const getProductCategories = async (params = {}) => {
  return await axiosInstance(options).post(`advertiser/product-categories/list`, { page: 1, per_page: 1000, ...params });
};

export const getProductSubCategories = async (categoryId, params = {}) => {
  return await axiosInstance(options).post(`advertiser/product-subcategories/list`, { categoryId: categoryId, page: 1, per_page: 1000, ...params });
};

export const getProductPreSubCategories = async (subcategoryId) => {
  return await axiosInstance(options).post(`advertiser/product-presubcategories/list`, { subcategoryId: subcategoryId, page: 1, per_page: 1000 });
};

export const getProductAttributes = async (categoryId) => {
  return await axiosInstance(options).post(`common/product-attribute-list`, { categoryId: categoryId });
};

export const getPreSubCategoryDetails = async (id) => {
  return await axiosInstance(options).get(`advertiser/product-presubcategories/details?_id=${id}`);
};

export const getColorPalettes = async () => {
  return await axiosInstance(options).get(`common/color-palettes`);
};

